import { Container, Typography } from "@mui/material"
import { MainComponent } from "components/common-styles"

const NotAuthorized = () => {
  return (
    <>
      <MainComponent component="main">
        <Container maxWidth={false}>
          <Typography sx={{ mt: 10, textAlign: "center" }} variant="h3">
            You are not authorized
          </Typography>
        </Container>
      </MainComponent>
    </>
  )
}

export default NotAuthorized
